import { api } from "#app/http/api";
import { Contact } from "#modules/contacts/infra/Contact.dto";

export type CreateContactDto = {
  clientId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | undefined;
};

export const createContact = async (payload: CreateContactDto): Promise<Contact | null> => {
  const response = await api.contacts.create.mutation({ body: payload });

  if (response.status === 201) {
    return response.body;
  }

  return null;
};
